import React from "react";

import { Box, Grid, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import Summary from "./Summary";
import StoreVsComparatorPerformance from "./StoreVsComparatorPerformance";
import StoreClusteringGroup from "./StoreClusteringGroup";
import StoreClusteringGroupSubtitle from "./StoreClusteringGroupSubtitle";

const StoreClustering: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const scrollMarginTop = isMobile ? theme.spacing(18) : theme.spacing(3);

    return (
        <Box style={{ scrollMarginTop: scrollMarginTop }}>
            <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                    <Summary />
                </Grid>
                <Grid item md={6} xs={12}>
                    <StoreVsComparatorPerformance />
                </Grid>
                <Grid item xs={12}>
                    <StoreClusteringGroupSubtitle />
                </Grid>
                <Grid item xs={12}>
                    <StoreClusteringGroup />
                </Grid>
            </Grid>
        </Box>
    );
};

export default StoreClustering;
